import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 5,      
      retryDelay: (attempt) => attempt === 0 ? 1000 : 1500,
      refetchOnWindowFocus: false,
    },
  },
});